import Immutable from "seamless-immutable";
import initialState from "./initialState";
import {types} from "../actions/externalOfferActions";
import {TableModel} from "../models/TableModel";

export default function externalOfferReducer(state = Immutable(initialState.externalOffer), action) {
  switch (action.type) {
    case types.GET_EXTERNAL_OFFER_LIST: {
      return state.merge({
        fetching: true,
        pagedData: TableModel.pageRequested(state.pagedData, action.pageNumber, action.pageSize, action.filterBy, action.sortBy),
      });
    }
    case types.GET_EXTERNAL_OFFER_LIST_SUCCESS: {
      return state.merge({
        fetching: false,
        pagedData:
          TableModel.pageReady(state.pagedData, action.result.totalDataCount, action.result.data)
      });
    }
    case types.GET_EXTERNAL_OFFER_LIST_FAILURE: {
      return state.merge({
        fetching: false,
      });
    }
    default:
      return state;
  }
}
